import { NgModule } from '@angular/core';

import { CustomProgressComponent } from './custom-progress.component';

@NgModule({
  imports: [],
  exports: [CustomProgressComponent],
  declarations: [CustomProgressComponent],
  providers: []
})
export class CustomProgressModule {}
